import { gql } from '@apollo/client';

export const GET_UNREAD_NOTIFICATIONS_COUNT_BY_USER = gql`
  query getUnreadNotificationsCountByUser($userId: ID!) {
    getNotificationsByUser(userId: $userId, filterOptions: { isAcknowledged: false }) {
      total
    }
  }
`;
